
import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Offer } from '../../../model/offer';
import { OfferCategory } from '../../../model/offer-category.model';

import { SharedService } from '../../../_services/shared.service';
import { ThemeService } from '../../../_services/theme.service';

import { BsModalService } from 'ngx-bootstrap/modal';
import { Observable, map } from 'rxjs';
// import { OfferPhotoGalleryComponent } from '../../offer-photo-gallery/offer-photo-gallery.component';



import { UiNewOfferCardComponent } from '../ui-new-offer-card/ui-new-offer-card.component';
import { UiNewOfferCardAddonComponent } from '../ui-new-offer-card-addon/ui-new-offer-card-addon.component';
import { UiNewOfferCardAncillaryComponent } from '../ui-new-offer-card-ancillary/ui-new-offer-card-ancillary.component';
import { UiNewOfferPhotoGalleryComponent } from '../ui-new-offer-photo-gallery/ui-new-offer-photo-gallery.component';

@Component({
  selector: 'ui-new-offer-card-list-responsive',
  standalone: true,
  imports: [CommonModule, UiNewOfferCardComponent, UiNewOfferCardAddonComponent, UiNewOfferCardAncillaryComponent],
  providers: [BsModalService],
  templateUrl: './ui-new-offer-card-list-responsive.component.html',
  styleUrl: './ui-new-offer-card-list-responsive.component.scss',
})
export class UiNewOfferCardListResponsiveComponent implements OnInit, AfterViewInit {
  private _offers: Offer[] = [];

  @Input()
  set offers(value: Offer[] | null | undefined | object) {
    if (Array.isArray(value)) {
      this._offers = value;
    } else if (value && typeof value === 'object' && 'offers' in value && Array.isArray((value as any).offers)) {
      this._offers = (value as any).offers;
    } else {
      this._offers = [];
    }
  }
  get offers(): Offer[] {
    return this._offers;
  }

  propertyId = '';
  offerAliasId = '';

  @Input() viewMoreToggle = false;
  @Input() activeOfferType: OfferCategory = 'ROOM';
  @Input() requestOnlyMode = false;
  @Input() viewMode: 'tiles' | 'list' = 'tiles';

  modalActive = false;
  modalClose$!: Observable<boolean>;
  modalOpen$!: Observable<boolean>;

  constructor(
    public sharedService: SharedService,
    public themeService: ThemeService,
    private modalService: BsModalService,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.propertyId = this.route.snapshot.paramMap.get('prop_id') ? (this.route.snapshot.paramMap.get('prop_id') as string) : '';
    this.offerAliasId = this.route.snapshot.paramMap.get('alias_id') ? (this.route.snapshot.paramMap.get('alias_id') as string) : '';

    document.documentElement.style.overflowY = 'auto';
  }

  ngAfterViewInit(): void {
    this.modalClose$ = this.modalService.onHide.pipe(
      map(() => {
        this.modalActive = false;
        return true;
      }),
    );

    this.modalClose$.subscribe(() => {
      document.getElementsByTagName('body')[0].style.overflow = 'auto';
      this.modalActive = false;
    });

    this.modalOpen$ = this.modalService.onShow.pipe(
      map(res => {
        this.modalActive = true;
        return res;
      }),
    );

    this.modalOpen$.subscribe(() => (this.modalActive = true));

    this.cdr.detectChanges();
  }

  openModal(index: number) {
    if (this.sharedService.offers) {
      this.sharedService.setSelectedOffer(index, this.sharedService.offers, false);
    }

    this.modalService.show(UiNewOfferPhotoGalleryComponent, {
      ...this.sharedService.config,
      initialState: {
        offer: this.sharedService.offer,
        index: index,
      },
    });
  }

  getOfferFilterValue(offerFilter: string): boolean {
    return this.sharedService.getOfferFilterActive(offerFilter);
  }
}
